import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbToastrService
} from '@nebular/theme';
import { Subject, takeUntil } from 'rxjs';
import { BatchJobService } from 'src/app/core/services/batch-job.service';
import { InsightWebSocketService } from 'src/app/core/services/web-socket.service';

@Component({
  selector: 'app-insight-terminate-modal',
  templateUrl: './insight-terminate-modal.component.html',
  styleUrls: ['./insight-terminate-modal.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class InsightTerminateModalComponent implements OnDestroy {
  private unsubscribe = new Subject<void>();

  public insight_id?: number;
  public batch_job_id?: string;
  public reason = '';

  constructor(
    protected ref: NbDialogRef<InsightTerminateModalComponent>,
    private service: BatchJobService,
    private socketService: InsightWebSocketService,
    private toastr: NbToastrService
  ) {}

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public terminate() {
    if (this.batch_job_id) {
      this.service
        .terminateJob(this.batch_job_id, this.reason)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data.message === 'successful') {
            this.socketService.closeWindow(data.job_id);
            this.ref.close(true);
          }
        });
    } else {
      this.toastr.danger('', $localize`No Batch Job ID provided.`);
    }
  }

  public close() {
    this.ref.close(false);
  }
}
